export default {
    black: '#222222',

    error: '#ff3838',
    info: '#38afff',
    light: '#ffffff',

    neutral: '#ffffff',

    primary: '#8A9771',
    primaryDark: '#707b5b',
    primaryLight: '#a2ad90',

    secondary: '#39402f',
    secondaryDark: '#1f231a',
    secondaryLight: '#545e45',
    success: '#0dff82',

    tertiary: '#39402f',
    tertiaryDark: '#1f231a',
    tertiaryLight: '#545e45',
    warning: '#ffc830',
    white: '#ffffff',
}
